import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "gtr-searching",
  role: "status",
  "aria-live": "polite"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("i", {
      class: "fas fa-cog fa-fw fa-spin me-2",
      "aria-hidden": "true"
    }, null, -1),
    _createElementVNode("span", null, "Buscando…", -1)
  ]))]))
}